// aqui hay mas mms como total que va en el footer, etc...
// ver doc ngx-datatable message
export class DatatableMessage {
    emptyMessage: string;
    totalMessage: string;
    selectedMessage: string;
}
